const ROOT_URL = 'https://api.909.cn'
// const ROOT_URL = 'http://www.msmall.test'
module.exports = {
  BASE_URL: ROOT_URL,
  IMG_URL: ROOT_URL + '/storage/'
}
